import { render, staticRenderFns } from "./ModalAcordo.vue?vue&type=template&id=ce8e6446"
import script from "./ModalAcordo.vue?vue&type=script&lang=js"
export * from "./ModalAcordo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports